import React from 'react';
import PropTypes from 'prop-types';
import { group, stringInputSpec } from './editing-configs';

const defaultDimensions = {
  height: '232px',
  width: '100%',
};

const SoundCloudPlayer = ({
  soundCloudEpisodeId,
  podcastMediaWidth = defaultDimensions.width,
  podcastMediaHight = defaultDimensions.height,
  soundCloudPlayerColor,
}) => {
  const parseColor = (rawColor) => encodeURIComponent(rawColor);
  const src = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${soundCloudEpisodeId}&color=${parseColor(
    soundCloudPlayerColor
  )}&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=true`;

  if (!soundCloudEpisodeId) {
    return null;
  }

  return (
    <iframe
      id="soundcloud-iframe"
      width={podcastMediaWidth || defaultDimensions.width}
      height={podcastMediaHight || defaultDimensions.height}
      scrolling="no"
      frameBorder="no"
      src={src}
      title="Soundcloud podcast"
    />
  );
};

SoundCloudPlayer.propTypes = {
  soundCloudEpisodeId: PropTypes.string,
  podcastMediaWidth: PropTypes.string,
  podcastMediaHight: PropTypes.string,
  soundCloudPlayerColor: PropTypes.string,
};

SoundCloudPlayer.defaultProps = {
  soundCloudEpisodeId: '',
  podcastMediaWidth: '',
  podcastMediaHight: '',
  soundCloudPlayerColor: '#FF5500',
};

SoundCloudPlayer.getEditingConfigs = (_componentDocument, fieldName) => {
  const getInputName = (name) => (fieldName ? `${fieldName}.${name}` : name);
  return [
    stringInputSpec(getInputName('soundCloudEpisodeId'), 'Podcast episode URL'),
    group('Audio Details', [
      {
        help: 'The desired Spotify podcast episode URL',
      },
      stringInputSpec(getInputName('podcastMediaHight'), 'Podcast height', {
        help: 'The podcast frame height in pixels. Default value is 232px',
      }),
      stringInputSpec(getInputName('podcastMediaWidth'), 'Podcast width', {
        help: 'The podcast frame width in pixels or percentage. Default value is 100%',
      }),
      stringInputSpec(
        getInputName('soundCloudPlayerColor'),
        'Play Button Color HEX',
        {
          help: 'Color play button and other controls. e.g. "#FF5500"',
        }
      ),
    ]),
  ];
};

export default SoundCloudPlayer;
